import(/* webpackMode: "eager" */ "D:\\VQBITS\\BeyonliServices Project\\BeyonliServices\\frontend\\src\\app\\not-found.tsx");
